
import { Component, Prop, Vue } from 'vue-property-decorator';
import { get } from '@/services/http';
import { isUsableImageUrl } from '@/helpers/variantImage';

@Component({})
export default class CatalogSearchBar extends Vue {
  /**
   * The usable-image rule, exposed so the template can call it. A Vue class
   * component cannot call a module function from a template unless it is a
   * class property — without this the v-if evaluates `undefined` as a
   * function and Vue warns at runtime while the build stays green.
   */
  private isUsableImageUrl = isUsableImageUrl;

  @Prop({ required: true }) public readonly supplierId!: number;

  public query = '';
  public results: any[] = [];
  public loading = false;
  public selected: any = null;
  private debounceTimer: any = null;

  public beforeDestroy(): void {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = null;
    }
  }

  public onInput(q: string): void {
    clearTimeout(this.debounceTimer);
    const v = (q || '').trim();
    if (v.length < 2) { this.results = []; return; }
    this.debounceTimer = setTimeout(() => this.fetch(v), 300);
  }

  public async fetch(q: string): Promise<void> {
    const requestedQuery = q;
    this.loading = true;
    try {
      const resp: any = await get(`/supplier-products/supplier/${this.supplierId}/search`, { q, limit: 10 });
      if (this.query.trim() !== requestedQuery) { return; }
      this.results = resp.data?.products || [];
    } catch (_) {
      if (this.query.trim() === requestedQuery) {
        this.results = [];
      }
    } finally {
      if (this.query.trim() === requestedQuery || this.query.trim().length < 2) {
        this.loading = false;
      }
    }
  }

  public onSelect(item: any): void {
    if (!item) { return; }
    // Cancel any scheduled debounced fetch so it can't overwrite the
    // cleared results after the user has already picked a product.
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = null;
    }
    this.$emit('add-product', item);
    this.$nextTick(() => { this.selected = null; this.query = ''; this.results = []; });
  }
}
